const potentialCandidateApis = {
  new_candidate: '/api/potential-candidate-handbook/new-candidate',
  update_candidate: '/api/potential-candidate-handbook/update-candidate',
  delete_candidate: '/api/potential-candidate-handbook/delete-candidate',
  confirm_learn: '/api/potential-candidate-handbook/confirm-learn',
  change_confirm_sale_citizen_id:
    '/api/potential-candidate-handbook/change-confirm-sale-citizen-id',
};

export default potentialCandidateApis;
